import _ from 'lodash'

export function getPricingSchemes (menuBlob) {
  return _.get(menuBlob, 'pricingSchemes', [])
}

export function getPricingScheme (id, menuBlob) {
  return getPricingSchemes(menuBlob).find(it => it.id === id)
}

export function getDefaultPricingScheme (menuBlob) {
  return getPricingSchemes(menuBlob).find(it => it.isDefault)
}

export function getDefault3rdPartyPricingScheme (menuBlob) {
  return getPricingSchemes(menuBlob).find(it => it.default3rdParty)
}
